<template>
	<section>
		<div class="table-wrapper b-table">
			<table class="table">
				<tr>
					<th class="is-narrow">
						<b-checkbox v-model="selectedAll"></b-checkbox>
						<!-- <b-checkbox v-model="archiveCheckedListAll" v-if="params.active"></b-checkbox>
						<b-checkbox v-model="restoreCheckedListAll" v-else></b-checkbox> -->
					</th>
					<th>NAME</th>
				</tr>
				<tr v-for="(user, key) in users">
					<td>
						<b-checkbox v-model="selected" :native-value="user.id"></b-checkbox>
						<!-- <b-checkbox v-model="archiveCheckedList" :native-value="code.id" v-if="code.status"></b-checkbox>
	              		<b-checkbox v-model="restoreCheckedList" :native-value="code.id" v-else></b-checkbox> -->
					</td>
					<td>{{ user.fullName }}</td>
				</tr>
			</table>
        </div>
	</section>
</template>
<script>
import { UserService } from "@/services/user.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
export default {
	props: [ 'firm', 'organization', 'selectedPersons' ],
    data: () => ({
    	users: [],
    	selected: [],
    	selectedAll: false,
    }),
    watch: {
    	organization() {
	    	this.fetch();
    	},
    	selected(value) {
    		this.$emit('update:selectedPersons', value);
    	},
    	selectedAll(value) {
    		if (value) {
    			this.selected = this.users.map(element => element.id);
    		} else {
    			this.selected = [];
    		}
    	}
    },
    methods: {
        async fetch() {
            await UserService.all({ archived: false, order_by:'asc', sort_by: 'desc', per_page: 1000, page: 1, firmId: this.organization.id,
                filter_by:'first_name', order_by:'asc' })
                .then(response => {
                    this.users = JsonDenormalizer.denormalize(response);
            	});

        },
    },
    mounted() {
    	this.fetch();
    }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Organization/organizationData/codes/persons.vue